import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, ViewChild, inject } from '@angular/core'

import { Store } from '@ngrx/store'
import { MenuItem } from 'primeng/api'
import { Menu, MenuModule } from 'primeng/menu'
import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { toNodeActionsMenu } from '@flowx/designer/modules/bpmn-editor/bpmn-actions.util'
import {
  NodeBarAction,
  NodeMenuAction,
  isNodeMenuAction,
} from '@flowx/designer/modules/bpmn-editor/bpmn-graph.constants'
import { BpmnActionsStore } from '@flowx/designer/modules/bpmn-editor/components/bpmn-editor-node-actions/store/bpmn-editor-actions.store'
import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'

import { BPMNNodeActionsEffectsService } from './store/bpmn-node-actions.effects'

@Component({
  selector: 'app-bpmn-editor-node-actions',
  imports: [
    CommonModule,
    FlxClickStopPropagationDirective,
    TooltipModule,
    FlxButtonModule,
    FlxIconModule,
    MenuModule,
  ],
  templateUrl: './bpmn-editor-node-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bpmn-editor-node-actions.component.scss'],
})
export class BpmnEditorNodeActionsComponent {
  @Input() actions: BpmnActionsStore
  @ViewChild('nodeActions') nodeActionsRef
  @Input() maxWidth?: number
  @Input() readonly?: boolean = false

  readonly store = inject(Store)
  readonly storeEffectsService = inject(BPMNNodeActionsEffectsService)
  menuModel: MenuItem[] = []

  get nodeActionsPanelEl(): HTMLElement {
    return this.nodeActionsRef.nativeElement
  }

  get barActions(): NodeBarAction[] {
    return this.actions.options.filter(
      (action): action is NodeBarAction => !isNodeMenuAction(action)
    )
  }

  get overflowActions(): NodeMenuAction[] {
    return this.actions.options.filter(isNodeMenuAction)
  }

  openOverflow(event: Event, menu: Menu): void {
    this.menuModel = toNodeActionsMenu(this.overflowActions, this.store)
    menu.toggle(event)
  }
}
